/*
  Help in the header (snippets/ps-help-button.liquid) with either version of
  the app's /chat/widget.js.

  The new widget (launcher: "header") opens its side panel itself when a
  [data-ps-chatbot-open] button is pressed, and sets
  window.PhotosymbolsChatbot.open. The old one ignores the launcher setting
  and only opens from its own floating pill, which ps-nav.css hides. With
  the old widget this presses that hidden pill instead, so Help works
  whichever widget the app is serving. Remove that part once the app's
  header-mode widget is live everywhere.

  It also writes where the header ends to --ps-header-bottom on <html>, so
  ps-nav.css can start the chat window just below the header. The header's
  height changes with the screen width, so it is measured, not hard-coded.
  Keep this part when the old-widget part goes.
*/
(function () {
  function markHeaderBottom() {
    var header = document.getElementById("shopify-section-header");
    if (!header) return;
    var bottom = Math.round(header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty("--ps-header-bottom", bottom + "px");
  }

  markHeaderBottom();
  window.addEventListener("resize", markHeaderBottom);

  function oldWidgetPill() {
    var config = window.PhotosymbolsChatbot || {};
    if (typeof config.open === "function") return null; // new widget: it handles the click
    return document.querySelector(".ps-chatbot-btn");
  }

  function oldChatIsOpen() {
    var frame = document.querySelector(".ps-chatbot-frame-container");
    return !!(frame && frame.classList.contains("ps-open"));
  }

  function markHelpButtons(open) {
    document.querySelectorAll("[data-ps-chatbot-open]").forEach(function (button) {
      button.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  document.addEventListener("click", function (event) {
    var help = event.target.closest && event.target.closest("[data-ps-chatbot-open]");
    if (!help) return;
    markHeaderBottom();
    var pill = oldWidgetPill();
    if (!pill) return;

    event.preventDefault();
    pill.click();
    markHelpButtons(oldChatIsOpen());
  });

  // The old widget has no Escape. Escape typed inside the chat itself
  // doesn't reach this page (the chat is in a frame from the app).
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var pill = oldWidgetPill();
    if (!pill || !oldChatIsOpen()) return;

    pill.click();
    markHelpButtons(false);
    var help = document.querySelector("[data-ps-chatbot-open]");
    if (help) help.focus();
  });
})();
